"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SELECT_ALL_ID = exports.ORDER = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Button = _interopRequireDefault(require("../Button"));

var _SwitcherArrow = _interopRequireDefault(require("./SwitcherArrow"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var baseCls = 'lt-switcher'; // Item with this id will be treated as select all

var SELECT_ALL_ID = 'ANY';
exports.SELECT_ALL_ID = SELECT_ALL_ID;
var ORDER = {
  ASC: 'asc',
  // ascending order
  DESC: 'desc' // descending order

};
exports.ORDER = ORDER;

var notSelected = function notSelected(item) {
  return !item.selected;
};

var itemDisabled = function itemDisabled(item) {
  return item.disabled || item.id === SELECT_ALL_ID;
};

var Switcher = function Switcher(_ref) {
  var list = _ref.list,
      order = _ref.order,
      onChange = _ref.onChange,
      isMobile = _ref.isMobile,
      className = _ref.className;
  var reverse = order === ORDER.DESC;
  var items = reverse ? (0, _toConsumableArray2["default"])(list).reverse() : list;
  var allDisabled = list.every(itemDisabled);
  var hasActive = false;
  var itemList = items.map(function (item, itemIndex) {
    var selected = item.selected,
        disabled = item.disabled,
        id = item.id,
        label = item.label;
    var active = false;

    if (!allDisabled) {
      hasActive = hasActive || selected;
      var selectAll = id === SELECT_ALL_ID;
      active = selectAll ? list.every(notSelected) : hasActive && !disabled || selected;
    }

    var showArrow = itemIndex === list.length - 1;

    var handleClick = function handleClick(e) {
      e.preventDefault();
      onChange(item);
    };

    return /*#__PURE__*/_react["default"].createElement(StyledSwitcherItem, {
      key: id,
      className: active ? "".concat(baseCls, "-item__active") : null,
      active: active,
      disabled: disabled && !allDisabled,
      onClick: handleClick
    }, label, showArrow && /*#__PURE__*/_react["default"].createElement(_SwitcherArrow["default"], {
      reverse: reverse,
      active: active
    }));
  });
  return /*#__PURE__*/_react["default"].createElement(StyledSwitcher, {
    className: className,
    reverse: reverse,
    isMobile: isMobile
  }, itemList);
};

var boxShadowTopBottom = 'inset 0 1px 0 0 #919499, inset 0 -1px 0 0 #919499';
var boxShadowLeft = 'inset 1px 0 0 0 #919499';
var boxShadowRight = 'inset -1px -1px 0 0 #919499';
var delimeterStyle = (0, _styledComponents.css)(["content:'';position:absolute;top:50%;width:1px;transform:translateY(-50%);height:85%;background:", ";", " ", " ", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.frenchGray;
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile && (0, _styledComponents.css)(["height:calc(100% - 1px);background:", ";"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.greyLight;
  });
}, function (_ref5) {
  var reverse = _ref5.reverse;
  return reverse && (0, _styledComponents.css)(["right:-1px;"]);
}, function (_ref6) {
  var reverse = _ref6.reverse;
  return !reverse && (0, _styledComponents.css)(["left:-1px;"]);
});
var delimeterStyleActive = (0, _styledComponents.css)(["", ";height:33%;background:#93cffc;"], delimeterStyle);
var borserRadiusStyle = (0, _styledComponents.css)(["border-radius:", ";", ";"], function (_ref7) {
  var reverse = _ref7.reverse;
  return reverse ? '0 2px 2px 0' : '2px 0 0 2px';
}, function (_ref8) {
  var isMobile = _ref8.isMobile,
      reverse = _ref8.reverse;
  return isMobile && (0, _styledComponents.css)(["border-radius:", ";"], reverse ? '0 20px 20px 0' : '20px 0 0 20px');
});
var StyledSwitcherItem = (0, _styledComponents["default"])(_Button["default"]).attrs({
  functional: true
}).withConfig({
  displayName: "Switcher__StyledSwitcherItem",
  componentId: "sc-1lq6k1f-0"
})(["position:relative;display:flex;flex:1 1 100%;justify-content:center;align-items:center;padding:0 10px 0 9px;white-space:nowrap;color:#4c4c4c;outline:none;", ";", ";"], function (_ref9) {
  var disabled = _ref9.disabled,
      theme = _ref9.theme;
  return disabled && (0, _styledComponents.css)(["color:", ";"], theme.colors.frenchGray);
}, function (_ref10) {
  var active = _ref10.active,
      theme = _ref10.theme;
  return active && (0, _styledComponents.css)(["color:", ";", ";box-shadow:inset 0 1px 0 0 rgba(0,0,0,0.2);"], theme.colors.white, theme.gradient.darkBlueToLight());
});

var StyledSwitcher = _styledComponents["default"].div.withConfig({
  displayName: "Switcher__StyledSwitcher",
  componentId: "sc-1lq6k1f-1"
})(["", ";display:flex;justify-content:space-between;box-shadow:", ",", ";", "{&:first-child{", ";}&:last-child{", "}&:not(.", "-item__active) +:not(.", "-item__active):after{", "}&.", "-item__active + .", "-item__active:after{", ";}}", ";"], borserRadiusStyle, boxShadowTopBottom, boxShadowLeft, StyledSwitcherItem, borserRadiusStyle, function (_ref11) {
  var reverse = _ref11.reverse;
  return reverse ? (0, _styledComponents.css)(["padding-left:2px;"]) : (0, _styledComponents.css)(["padding-right:2px;"]);
}, baseCls, baseCls, delimeterStyle, baseCls, baseCls, delimeterStyleActive, function (_ref12) {
  var reverse = _ref12.reverse;
  return reverse && (0, _styledComponents.css)(["flex-direction:row-reverse;box-shadow:", ",", ";"], boxShadowTopBottom, boxShadowRight);
});

Switcher.propTypes = {
  className: _propTypes["default"].string,
  list: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    selected: _propTypes["default"].bool,
    disabled: _propTypes["default"].bool
  })).isRequired,
  onChange: _propTypes["default"].func.isRequired,
  order: _propTypes["default"].oneOf(Object.values(ORDER)),
  isMobile: _propTypes["default"].bool
};
Switcher.defaultProps = {
  className: '',
  order: ORDER.ASC,
  isMobile: false
};
var _default = Switcher;
exports["default"] = _default;